import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    account: {},
    headerData: {},
    wishlist: {},
  },
  reducers: {
    setAccount: (state, action) => {
      state.account = action.payload;
    },
    setHeader: (state, action) => {
      state.headerData = action.payload;
    },
    setWishlist: (state, action) => {
      state.wishlist = action.payload;
    },
  },
});

// Export actions for dispatching
export const { setAccount, setHeader, setWishlist } = userSlice.actions;

// Export the reducer to include in the store
export default userSlice.reducer;
